module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter One")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“Last night I dreamt you finally got laid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris blinked and his hand froze halfway toward the fruit bowl. “Glad I’m getting sex "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("somewhere.")]), _vm._v("” He grabbed the last pear and took a bite. “Was it someone devilishly handsome or a girl?” His face twisted in disgust. “It wasn’t you, was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Caris looked down at her biology textbook. “I doubt it, since I didn’t wake up with the lingering taste of vomit in my mouth.” Chris tossed the pear at her, and she just barely managed to dodge. “If I had a dream about you and me having sex, I wouldn’t tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wouldn’t want you to tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thus we are agreed.” She stabbed at his hand with her fork when it strayed too close to her pancakes, but he managed to avoid it and snag a stray piece. “I have a final tomorrow, by the way, so on the off chance that you do find someone willing to offer you a mercy fuck, go to their place so I won’t be inconvenienced by the need to castrate you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Noted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And since my chances are much better, I’ll do the same during your finals next week so you can study.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris shrugged nonchalantly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Caris sighed. “They’re going to accuse you of cheating again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am cheating.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, you’re picking the answers out of the profs’ brains using telepathy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris regarded her with a raised eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Huh. When I say it that way, it does sound a lot like cheating, doesn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded and stole another pancake.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t you just quit? You don’t want to be a vet. I haven’t seen you within five feet of an animal without you getting that look on your face.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What look?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Imagine me naked. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("That")]), _vm._v(" look. Vaguely terrified, not sure if you should be amused or disgusted. You get the same look around kids.” She rolled up the last pancake and shoved the entire thing into her mouth before he could make a play for it. She continued with a cough, “I don’t think that’s going to go over very well when poor Fluffy is bleeding out on the operating table.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Recognizing the beginning of an old argument, Chris stood and crossed the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Chris, as your self-appointed best friend, I feel uniquely qualified to tell you that even though you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("think")]), _vm._v(" you’re doing what Brennan would want you to do, you’re not. He’d just want you to be happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris slumped against the counter. “I know. But I need to do this for him.” They had a longstanding agreement that he wouldn’t deliberately read her mind, but he couldn’t help the projections she shot his way. Worry. Warmth. Love. Frustration. Hope. It was a jumbled kaleidoscope of emotions that always threw him off, and her earnest concern was just enough to unnerve him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They had stumbled into their friendship during freshman year when their roommates started dating. Caris had shown up at his door one night, grumbling about oversexed jocks and inconsiderate bimbos, and dumped her stuff in the spare bedroom. Since then, it had been her bed, her room and her rules. Chris hadn’t heard from the oversexed jock in question since the idiot had come whining at the door for his bed back and been frightened away by Caris’s pre-coffee face.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Glancing at her watch, Caris sighed and stood. “Just…think about it, okay? You’re not going to be happy as a vet. And you shouldn’t have to find that out the hard way.” She disappeared into her room to dress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chris picked his way through the minefield in their front hallway to retrieve his backpack. He shouted a quick goodbye, shouldered his bag and headed to class.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lingering frost was still making the mornings crisp, but it was nice to be on campus during springtime. He lost himself in the flock of students headed to their first class of the day, Caris’s words persistent in his mind. Of all her annoying habits, her uncanny ability to hit home with painful truths was his least favorite. He didn’t need her pointing out that Brennan would have wanted better for him. But he couldn’t stop himself from trying to live the life that his brother had wanted. And he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("would")]), _vm._v(" be a vet. Maybe not a good one, but he would make Bren proud.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If he could avoid getting tossed out on his ass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was early to class and settled into a seat near the window, his thoughts drifting as another group of students arrived. Caris had been right about the rest of it too…They were going to get on his case for cheating again, but it was too hard to stop. Bouncing between foster homes after his father’s car accident had ingrained in him the need for good behavior, but he’d never been studious. If he didn’t bring home good grades, he got shit. So instead of trying to apply himself and failing, he’d used the gift he so despised. It was easy. People’s brains were like libraries, and he’d gotten pretty good at finding relevant information and recycling it onto paper. It was even easier when people projected their surface thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“…Christian Kincaid?” His professor stood at the front of the class, attendance roster in hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Present.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Such a waste of humanity. Don’t know why he’s even here…He’s obviously better suited for a job at a grocery store.")]), _vm._v(" Dr. Peterson’s stray thought was laced with contempt and flashed through Chris’s brain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stiffened in his seat. It wasn’t the first time he’d picked condemning thoughts out of the other man’s head, but it didn’t stop it from sucking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like clockwork, Peterson finished attendance at exactly three minutes past the hour and launched directly into his PowerPoint deck. Chris settled in his seat and looked out the window at the quad below, Caris’s points still traitorously insinuated in his thoughts. The sad thing was that even if he did quit, he wouldn’t know what to do with his life. His only talent was screwing up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And perhaps Mr. Kincaid can tell us the leading cause of UTI in cats?” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urolithiasis.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reading thoughts was like having access to Google. “Urolithiasis.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In layman’s terms?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stones blocking the tract.” He couldn’t wait until the semester was over. Dr. Peterson had tried to call him out on cheating twice already, and he felt like a shitbag every time he defended himself to the dean.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Why couldn’t Brennan have wanted to be something more up my alley? Like a photographer. Or a rock diva.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And the leading observable bacteria?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“E. coli, Pseudomonas, Proteus mirabilis…Do you want me to go on?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Peterson’s face pinched. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How is the little shit doing it?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Enterococcus, Klebsiella—”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They glared at each other, and an uncomfortable silence descended on the class. Chris bit his tongue, feeling every eye on him. His face flushed with the attention and he dropped his eyes. All he wanted was to get through the next three semesters, accept his degree and get the hell out of here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Brennan would want you to be happy.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Well,")]), _vm._v(" Chris thought, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("if that was really the case, he shouldn’t have let me kill him.")])])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a66c0da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426890574_ch01.vue
// module id = 81
// module chunks = 0